/*
 * @Author: Junchi Zhao
 * @LastEditors: Please set LastEditors
 * @Description:
 */
const cockpit = () => import("@/pages/cockpit/index");
const home = () => import("@/pages/cockpit/home/index");
const useActivity = () => import("@/pages/cockpit/useActivity/index");
const traceSource = () => import("@/pages/cockpit/traceSource/index");
const supervise = () => import("@/pages/cockpit/supervise/index");
const keepOnRecord = () => import("@/pages/cockpit/keepOnRecord/index");
const monitor = () => import("@/pages/cockpit/monitor/index");
export default [
  {
    path: "/cockpit",
    redirect: "/cockpit/index",
    name: "cockpit",
    component: cockpit,
    meta: {
      title: "驾驶舱",
      noCache: true,
      affix: false,
      path: ""
    },
    children: [
      {
        path: "/cockpit/index",
        name: "cockpitHome",
        component: home,
        meta: {
          title: "首页",
          noCache: true,
          affix: true,
          path: ""
        }
      },

      {
        path: "/cockpit/useActivity",
        name: "useActivity",
        component: useActivity,
        meta: {
          title: "使用活跃度",
          noCache: true,
          affix: true,
          path: ""
        }
      },

      {
        path: "/cockpit/traceSource",
        name: "traceSource",
        component: traceSource,
        meta: {
          title: "消费者溯源",
          noCache: true,
          affix: true,
          path: ""
        }
      },

      {
        path: "/cockpit/supervise",
        name: "supervise",
        component: supervise,
        meta: {
          title: "生产监管",
          noCache: true,
          affix: true,
          path: ""
        }
      },

      {
        path: "/cockpit/keepOnRecord",
        name: "keepOnRecord",
        component: keepOnRecord,
        meta: {
          title: "主体备案",
          noCache: true,
          affix: true,
          path: ""
        }
      }
    ]
  },
  {
    path: "/monitor",
    name: "monitor",
    component: monitor,
    meta: {
      title: "实时监控",
      noCache: true,
      affix: false,
      path: ""
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/cockpit.js